import React, { useState, useRef, useEffect } from "react";
import { IonApp, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../../menus/Nursery/EnvironmentScience";
import { Helmet } from "react-helmet";

const EnvironmentScience: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    useEffect(() => {
        document.title = "Mamas Guidance - Nursery - Environment Science"; // Set page title
    }, []);

    return (
        <>
            <Helmet>
                <meta name="description" content='Introduce nursery kids to the world around them with environmental science activities on Mamas Guidance—covering basic topics like plants, animals, seasons, weather, and healthy habits through fun and simple learning exercises.' />
            </Helmet>
            <div className={`my-topic-container`}>
            {topics.map((slide, index) => (
                <IonItem key={index} routerLink={slide.url}
                    routerDirection="none"
                    lines="none"
                    detail={true}>
                    <IonLabel>{slide.title}</IonLabel>
                </IonItem>
            ))}
        </div>
        </>
    );
};
export default EnvironmentScience;